import React, { Component, useEffect, useRef, useState } from 'react';
import Contacto from '../../components/contacto/contacto';
import ContactoPromo from '../../components/contacto/contactoPromo';
import './terminos.scss';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { HOST } from '../../data/config';
import FormularioReferidos from '../../components/contacto/formularioReferidos';
import { MailService } from '../../components/common/Http/MailService';
import { templateShare } from './correo';

export const Terminos = () => {
	const ref = useRef(null);
    const ref2 = useRef(null);
    const refSubmit = useRef(null);
    const mailgun = new MailService()
    const params = useParams();
    const [benefit, setBenefit] = useState({
		name: '',
	});

    const replaceSpecialChars = (str) => {
        return str.replace(/ñ/g, 'n');
    }
    const convertKbtoMb = (str) => {
        const kb = parseFloat(str);
        return parseInt(kb / 1024);
    }
	const fetching = async props => {
		const response = await fetch(HOST + '/wp-json/custom-api/v1/benefit?name=' + replaceSpecialChars(params?.beneficio));
		const data = await response.json();
        setBenefit(data);
	};


	const clipBoard = (refence) => {
        navigator.clipboard.writeText(refence.current.value);
    }

    const sendEmail = async (e) => {
        refSubmit.current.disabled = true
        refSubmit.current.textContent = 'Enviando...'


        mailgun.from("Casaideal <no-reply@casaideal.com.pe>")
            .to(ref2?.current.value)
            .subject("Referidos")
            .html(templateShare()).send().then(r => {
                refSubmit.current.disabled = false
                refSubmit.current.value = 'Enviar'
            })

        const interval = setInterval(() => {
            refSubmit.current.disabled = false
            refSubmit.current.value = 'Enviar'
            clearInterval(interval)
        }, 2000);
    
        
    }
    const close = ()=>{
        try {
            let btn = document.querySelector('.modal-referido')
            btn.classList.remove('active')
        } catch (error) {
            
        }
    }

	useEffect(() => {
		fetching();
	}, []);
    
	return (
		<div className='page-terminos'>
			<div className='modal-referido'>
                <div className='modal '>
                    <div className='icon-close mask' onClick={()=>{close()}}>
                    </div>
                    <span className='text-letter text-title-1-8 text-center mb-3'>Ahora puedes compartir el enlace con tus familiares y amigos</span>
                    <div className='mb-2'>
                        <span className='text-letter'>Comparte por tus redes sociales favoritas</span>
                        <div className='flex gap-1'>
                            <a href="https://api.whatsapp.com/send?text=Mira%20los%20proyectos%20que%20tenemos%20para%20ti:%20https://casaideal.com.pe/proyectos-en-venta" target="_blank" className='rounded-full bg-white w-5 h-5 flex items-center justify-center bg-black' style={{backgroundColor:'#25D366'}}>
                                <div className='icon-whatsapp w-4 h-3 bg-white'>
                                </div>
                            </a>
                            <a href="https://m.me/casaideal.com.pe?text=Mira%20los%20proyectos%20que%20tenemos%20para%20ti:%20https://casaideal.com.pe/proyectos-en-venta" target="_blank" className='rounded-full bg-white w-5 h-5 flex items-center justify-center bg-black' style={{backgroundColor:'#00B2FF'}}>
                            <div className='icon-messeger w-4 h-3 bg-white'>
                                </div>
                            </a>

                        </div>
                    </div>
                    <div className='mb-2'>
                        <span className='text-letter-80'>
                            O copia tu enlace y envía a tus amigos:
                        </span>
                        <div className='relative'>
                            <input className='input-style h-5 w-full pr-4' type='text' value='https://casaideal.com.pe/proyectos-en-venta' ref={ref}></input>
                            <div className='icon-copy w-3 h-3 bg-black absolute right-0 top-0 bottom-0 my-auto mr-1 cursor-pointer' onClick={(e)=>{clipBoard(ref)}}>
                            </div>
                        </div>
                    </div>
                    <div className='mb-2'>
                        <span className='text-letter-80'>
                            O envia un correo personalizado
                        </span>
                        <div className='relative flex gap-4'>
                            <input className='input-style h-5 w-full pr-4' type='text' ref={ref2}></input>
                            <button ref={refSubmit} type="submit" class="btn-submit btn-radio" onClick={(e)=>{sendEmail()}}>Enviar</button>
                        </div>
                    </div>
                   
                </div>
            </div>
			<section>
				<div className='SliderDepartamentos'>
					<div className='background d-flex'>
						<picture>
							<source className='background ' media='(min-width: 740px)' srcset={benefit?.imagen_banner?.url}></source>
							<img className='background' src={benefit?.imagen_miniatura?.url}></img>
						</picture>
					</div>
					<span className='title-background' dangerouslySetInnerHTML={{ __html: params.beneficio.replace(/-/g, ' ') }}></span>
				</div>
			</section>
			<section className='information container'>
				<div className='info'>
					<span className='handing-over bold'>Descripción</span>
					<div className='content-paragraph' dangerouslySetInnerHTML={{ __html: benefit?.description }}></div>
					<a href={benefit?.pdf?.url} target='_blank' className='btn-download outline-gray'>
						<div className='icon-button'>
							<img className='icon-download' src={require('../../Assets/iconos/icon-download.svg').default}></img>
						</div>
						<div className='text-button'>
							Términos y condiciones
							<span className='peso'>{convertKbtoMb(benefit?.pdf?.filesize)} kb</span>
						</div>
					</a>
					{benefit?.list_products && !!benefit?.list_products.length ? (
						<div className='content-all'>
                            {
                                benefit?.list_products.map((item)=>{
                                    return (<div className='content-list'>
                                        <h2 className='title-list'>{item.titulo}</h2>
                                        <div className='table'>
                                            <div className='header-table'>
                                                <div className='name-product'>Producto</div>
                                                <div className='cant-product'>Cantidad</div>
                                            </div>
                                            <div className='body-table'>
                                                {item.list.map(e => {
                                                    return (
                                                        <div className='line-product'>
                                                            <div className='name-product'>
                                                                <img className='img-product' src={e.image.url}></img>
                                                                {e.title}
                                                            </div>
                                                            <div className='cant-product'>{e.cant}</div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>)
                                })
                            }
						</div>
					) : null}
				</div>
				{
					benefit?.name.includes('referidos') ? 	<div className="form" id="formulario">
					<FormularioReferidos
						page={"benefits"}
						promo={benefit?.name}
						options={benefit?.projects_relations?.map((e)=>{return {text:e}}) ?? []}
					></FormularioReferidos>
					</div> :
					<div className='form' id='formulario'>
						<ContactoPromo page={'benefits'} promo={benefit?.name} options={benefit?.projects_relations?.map((e)=>{return {text:e}}) ?? []}></ContactoPromo>
					</div>  
				
				}
			</section>
		</div>
	);
};
